(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[4204],{

/***/ 8927:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/en/exhibition/apply",
      function () {
        return __webpack_require__(79955);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 79955:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "__N_SSP": function() { return /* binding */ __N_SSP; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(47568);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(97582);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var styled_jsx_style__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(60357);
/* harmony import */ var styled_jsx_style__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(styled_jsx_style__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var _index_module_scss__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(69288);
/* harmony import */ var _index_module_scss__WEBPACK_IMPORTED_MODULE_14___default = /*#__PURE__*/__webpack_require__.n(_index_module_scss__WEBPACK_IMPORTED_MODULE_14__);
/* harmony import */ var _douyinfe_semi_ui__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(49667);
/* harmony import */ var axios__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(9669);
/* harmony import */ var axios__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(axios__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var _stores__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(62010);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(93967);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(96486);
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(lodash__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var _utils_useHead__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(25838);
















var Apply = function(param) {
    var navDetail = param.navDetail;
    var router = (0,next_router__WEBPACK_IMPORTED_MODULE_5__.useRouter)();
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)([]), prodCate = ref[0], setProdCate = ref[1];
    var ref1 = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)([]), country = ref1[0], setCountry = ref1[1];
    var ref2 = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)([]), region = ref2[0], setRegion = ref2[1];
    var ref3 = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)([]), city = ref3[0], setCity = ref3[1];
    var ref4 = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(false), visible = ref4[0], setVisible = ref4[1];
    var ref5 = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(), verify = ref5[0], setVerify = ref5[1];
    var ref6 = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(), reload = ref6[0], setReload = ref6[1];
    var ref7 = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(""), cookie = ref7[0], setCookie = ref7[1];
    var formRef = (0,react__WEBPACK_IMPORTED_MODULE_2__.useRef)();
    // const checkbox = useRef<any>()
    var setIsHeadFoot = (0,react__WEBPACK_IMPORTED_MODULE_2__.useContext)(_stores__WEBPACK_IMPORTED_MODULE_6__/* .IndexContext */ .Z).setIsHeadFoot;
    var btnClick = (0,react__WEBPACK_IMPORTED_MODULE_2__.useCallback)(function() {
        // console.log('check', checkbox.current, formRef.current.getFormState().values);
        console.log(formRef.current.getFormState().values);
        // if (!checkbox.current) {
        //   Notification.open({
        //     content: '请先同意《数据保护条例-展商》',
        //     duration: 3,
        //   })
        //   return
        // }
        if (!verify) {
            _douyinfe_semi_ui__WEBPACK_IMPORTED_MODULE_3__/* .Notification.open */ .P_.open({
                content: "Please enter Security code",
                duration: 3
            });
            return;
        }
        formRef.current.validate().then(/*#__PURE__*/ (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)(function() {
            var data;
            return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_11__.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        return [
                            4,
                            axios__WEBPACK_IMPORTED_MODULE_4___default().post("/api/exhibitor_apply", (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z)({
                                lang: "cn",
                                captcha: verify,
                                cookie: cookie
                            }, formRef.current.getFormState().values))
                        ];
                    case 1:
                        data = _state.sent().data;
                        if (data.code == 1) {
                            _douyinfe_semi_ui__WEBPACK_IMPORTED_MODULE_3__/* .Notification.open */ .P_.open({
                                content: "Success",
                                duration: 3
                            });
                            formRef.current.reset();
                            window.location.href = "https://bj.infosalons.com.cn/VSCENTER2/exhibitor/CBCE24/login";
                            return [
                                2
                            ];
                        } else {
                            getVerify();
                            _douyinfe_semi_ui__WEBPACK_IMPORTED_MODULE_3__/* .Notification.open */ .P_.open({
                                content: data.msg,
                                duration: 3
                            });
                        }
                        return [
                            2
                        ];
                }
            });
        })).catch(function(err) {
            console.log(err, "err");
            _douyinfe_semi_ui__WEBPACK_IMPORTED_MODULE_3__/* .Notification.open */ .P_.open({
                content: "Please fill in the complete information",
                duration: 3
            });
        });
    }, [
        verify,
        cookie
    ]);
    var transOption = (0,react__WEBPACK_IMPORTED_MODULE_2__.useCallback)(function() {
        var arr = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [];
        return arr === null || arr === void 0 ? void 0 : arr.map(function(item) {
            return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z)({}, item), {
                key: item.id,
                value: item.id,
                label: item.name_en
            });
        });
    }, []);
    var initTree = function(list) {
        return list.map(function(item) {
            return {
                children: item.childlist && item.childlist.length > 0 ? initTree(item.childlist) : [],
                value: item.id,
                label: item.name_en,
                key: item.id
            };
        });
    };
    var getRegion = (0,react__WEBPACK_IMPORTED_MODULE_2__.useCallback)(function() {
        var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)(function(pid) {
            var data, arr;
            return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_11__.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        return [
                            4,
                            axios__WEBPACK_IMPORTED_MODULE_4___default().get("/api/get_region", {
                                params: {
                                    pid: pid
                                }
                            })
                        ];
                    case 1:
                        data = _state.sent().data;
                        arr = transOption((0,lodash__WEBPACK_IMPORTED_MODULE_8__.toArray)(data === null || data === void 0 ? void 0 : data.data));
                        !!pid ? setCity(arr) : setRegion(arr);
                        return [
                            2
                        ];
                }
            });
        });
        return function(pid) {
            return _ref.apply(this, arguments);
        };
    }(), []);
    var getData = (0,react__WEBPACK_IMPORTED_MODULE_2__.useCallback)(/*#__PURE__*/ (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)(function() {
        var data, ref, _data;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_11__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    getRegion(0);
                    getVerify();
                    return [
                        4,
                        axios__WEBPACK_IMPORTED_MODULE_4___default().get("/api/get_country")
                    ];
                case 1:
                    data = _state.sent().data;
                    setCountry(transOption(data === null || data === void 0 ? void 0 : data.data));
                    return [
                        4,
                        axios__WEBPACK_IMPORTED_MODULE_4___default().get("/api/product_category_list")
                    ];
                case 2:
                    ref = _state.sent(), _data = ref.data;
                    setProdCate(initTree(_data === null || _data === void 0 ? void 0 : _data.data));
                    return [
                        2
                    ];
            }
        });
    }), []);
    var arrayBufferToBase64 = (0,react__WEBPACK_IMPORTED_MODULE_2__.useCallback)(function(arrayBuffer) {
        var binary = "";
        var bytes = new Uint8Array(arrayBuffer);
        var len = bytes.byteLength;
        for(var i = 0; i < len; i++){
            binary += String.fromCharCode(bytes[i]);
        }
        return window.btoa(binary);
    }, []);
    var getVerify = (0,react__WEBPACK_IMPORTED_MODULE_2__.useCallback)(/*#__PURE__*/ (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)(function() {
        var ref, ref1, ref2, data;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_11__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        axios__WEBPACK_IMPORTED_MODULE_4___default().get("/api/get_verify")
                    ];
                case 1:
                    data = _state.sent().data;
                    setReload("data:image/png;base64," + arrayBufferToBase64(data === null || data === void 0 ? void 0 : (ref = data.data) === null || ref === void 0 ? void 0 : (ref1 = ref.img) === null || ref1 === void 0 ? void 0 : ref1.data));
                    setCookie(data === null || data === void 0 ? void 0 : (ref2 = data.data) === null || ref2 === void 0 ? void 0 : ref2.cookie);
                    return [
                        2
                    ];
            }
        });
    }), []);
    var renderLabel = function(param) {
        var className = param.className, onExpand = param.onExpand, data = param.data, onCheck = param.onCheck, checkStatus = param.checkStatus, expandIcon = param.expandIcon;
        var label = data.label;
        var isLeaf = !(data.children && data.children.length);
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("li", {
            className: className,
            role: "treeitem",
            onClick: isLeaf ? onCheck : onExpand,
            children: [
                isLeaf ? null : expandIcon,
                isLeaf ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    onClick: onCheck,
                    tabIndex: 0,
                    "aria-checked": checkStatus.checked
                }) : null,
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                    style: {
                        marginLeft: isLeaf ? "30px" : ""
                    },
                    children: label
                })
            ]
        });
    };
    (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(function() {
        setIsHeadFoot(false);
        getData();
        return function() {
            setIsHeadFoot(true);
        };
    }, []);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: "jsx-c261a8235e8d453e",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: "jsx-c261a8235e8d453e" + " " + ((_index_module_scss__WEBPACK_IMPORTED_MODULE_14___default().container) || ""),
                children: [
                    (0,_utils_useHead__WEBPACK_IMPORTED_MODULE_9__/* .getHead */ .c)(navDetail),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: "jsx-c261a8235e8d453e" + " " + ((_index_module_scss__WEBPACK_IMPORTED_MODULE_14___default().content) || ""),
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                                src: "/image/en/apply-banner.png",
                                alt: "",
                                className: "jsx-c261a8235e8d453e"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                className: "jsx-c261a8235e8d453e" + " " + ((_index_module_scss__WEBPACK_IMPORTED_MODULE_14___default().form) || ""),
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                        className: "jsx-c261a8235e8d453e" + " " + ((_index_module_scss__WEBPACK_IMPORTED_MODULE_14___default().title) || ""),
                                        children: [
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("h2", {
                                                className: "jsx-c261a8235e8d453e",
                                                children: [
                                                    "Booth Application",
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                                        className: "jsx-c261a8235e8d453e",
                                                        children: "Marked * are mandatory"
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                className: "jsx-c261a8235e8d453e",
                                                children: [
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                                        href: "/en",
                                                        className: "jsx-c261a8235e8d453e",
                                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                            style: {
                                                                backgroundColor: "#7a201e"
                                                            },
                                                            className: "jsx-c261a8235e8d453e" + " " + ((_index_module_scss__WEBPACK_IMPORTED_MODULE_14___default().backBtn) || ""),
                                                            children: "Return home"
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                                        href: "https://cbce2025.gration.cn/?exhibitor/login&lang=en",
                                                        target: "_blank",
                                                        className: "jsx-c261a8235e8d453e",
                                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                            className: "jsx-c261a8235e8d453e" + " " + ((_index_module_scss__WEBPACK_IMPORTED_MODULE_14___default().backBtn) || ""),
                                                            children: "Registered,Return to log in"
                                                        })
                                                    })
                                                ]
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h2", {
                                        className: "jsx-c261a8235e8d453e"
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_douyinfe_semi_ui__WEBPACK_IMPORTED_MODULE_3__/* .Form */ .l0, {
                                        getFormApi: function(formApi) {
                                            return formRef.current = formApi;
                                        },
                                        labelPosition: "left",
                                        labelWidth: "155px",
                                        labelAlign: "right",
                                        children: function(param) {
                                            var formState = param.formState, values = param.values, formApi = param.formApi;
                                            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                className: "jsx-c261a8235e8d453e",
                                                children: [
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("h3", {
                                                        className: "jsx-c261a8235e8d453e",
                                                        children: [
                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                                                className: "jsx-c261a8235e8d453e",
                                                                children: "*"
                                                            }),
                                                            "Booth Type"
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                        className: "jsx-c261a8235e8d453e" + " " + (classnames__WEBPACK_IMPORTED_MODULE_7___default()([
                                                            (_index_module_scss__WEBPACK_IMPORTED_MODULE_14___default().type),
                                                            "type"
                                                        ]) || ""),
                                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_douyinfe_semi_ui__WEBPACK_IMPORTED_MODULE_3__/* .Form.RadioGroup */ .l0.RadioGroup, {
                                                            field: "booth_type",
                                                            label: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                                                className: "jsx-c261a8235e8d453e"
                                                            }),
                                                            direction: "vertical",
                                                            rules: [
                                                                {
                                                                    required: true,
                                                                    message: "Please choose booth type"
                                                                }, 
                                                            ],
                                                            onChange: function() {
                                                                console.log(formRef.current);
                                                                formRef.current.reset([
                                                                    "square1",
                                                                    "square"
                                                                ]);
                                                            },
                                                            children: [
                                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_douyinfe_semi_ui__WEBPACK_IMPORTED_MODULE_3__/* .Form.Radio */ .l0.Radio, {
                                                                    value: "1",
                                                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                                        className: "jsx-c261a8235e8d453e" + " " + ((_index_module_scss__WEBPACK_IMPORTED_MODULE_14___default().radioRight) || ""),
                                                                        children: [
                                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                                                style: {
                                                                                    paddingRight: "18px"
                                                                                },
                                                                                className: "jsx-c261a8235e8d453e" + " " + ((_index_module_scss__WEBPACK_IMPORTED_MODULE_14___default().label) || ""),
                                                                                children: [
                                                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                                                                        className: "jsx-c261a8235e8d453e",
                                                                                        children: "Raw Space"
                                                                                    }),
                                                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                                                                        className: "jsx-c261a8235e8d453e",
                                                                                        children: "Min 18㎡"
                                                                                    })
                                                                                ]
                                                                            }),
                                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_douyinfe_semi_ui__WEBPACK_IMPORTED_MODULE_3__/* .Form.InputNumber */ .l0.InputNumber, {
                                                                                className: (_index_module_scss__WEBPACK_IMPORTED_MODULE_14___default().input),
                                                                                field: formRef.current.getValue("booth_type") == "1" ? "square" : "square1",
                                                                                hideButtons: true,
                                                                                min: 1,
                                                                                disabled: formRef.current.getValue("booth_type") != "1",
                                                                                placeholder: "Please enter the area",
                                                                                label: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                                                                    className: "jsx-c261a8235e8d453e"
                                                                                }),
                                                                                trigger: "blur",
                                                                                rules: [
                                                                                    {
                                                                                        required: formRef.current.getValue("booth_type") == "1",
                                                                                        message: "Please enter the area"
                                                                                    }, 
                                                                                ]
                                                                            })
                                                                        ]
                                                                    })
                                                                }),
                                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_douyinfe_semi_ui__WEBPACK_IMPORTED_MODULE_3__/* .Form.Radio */ .l0.Radio, {
                                                                    value: "2",
                                                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                                        className: "jsx-c261a8235e8d453e" + " " + ((_index_module_scss__WEBPACK_IMPORTED_MODULE_14___default().radioRight) || ""),
                                                                        children: [
                                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                                                className: "jsx-c261a8235e8d453e" + " " + ((_index_module_scss__WEBPACK_IMPORTED_MODULE_14___default().label) || ""),
                                                                                children: [
                                                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                                                                        className: "jsx-c261a8235e8d453e",
                                                                                        children: "Shell Scheme"
                                                                                    }),
                                                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                                                                        className: "jsx-c261a8235e8d453e",
                                                                                        children: "Min 9㎡"
                                                                                    })
                                                                                ]
                                                                            }),
                                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_douyinfe_semi_ui__WEBPACK_IMPORTED_MODULE_3__/* .Form.InputNumber */ .l0.InputNumber, {
                                                                                className: (_index_module_scss__WEBPACK_IMPORTED_MODULE_14___default().input),
                                                                                field: formRef.current.getValue("booth_type") == "2" ? "square" : "square1",
                                                                                hideButtons: true,
                                                                                min: 1,
                                                                                disabled: formRef.current.getValue("booth_type") != "2",
                                                                                placeholder: "Please enter the area",
                                                                                label: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                                                                    className: "jsx-c261a8235e8d453e"
                                                                                }),
                                                                                trigger: "blur",
                                                                                rules: [
                                                                                    {
                                                                                        required: formRef.current.getValue("booth_type") == "2",
                                                                                        message: "Please enter the area"
                                                                                    }, 
                                                                                ]
                                                                            })
                                                                        ]
                                                                    })
                                                                })
                                                            ]
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h3", {
                                                        className: "jsx-c261a8235e8d453e",
                                                        children: "Company Information"
                                                    }),
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                        className: "jsx-c261a8235e8d453e" + " " + ((_index_module_scss__WEBPACK_IMPORTED_MODULE_14___default().info) || ""),
                                                        children: [
                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_douyinfe_semi_ui__WEBPACK_IMPORTED_MODULE_3__/* .Form.Input */ .l0.Input, {
                                                                className: (_index_module_scss__WEBPACK_IMPORTED_MODULE_14___default().input),
                                                                field: "company_cn",
                                                                placeholder: "please enter the Company Name",
                                                                label: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                                                    className: "jsx-c261a8235e8d453e" + " " + ((_index_module_scss__WEBPACK_IMPORTED_MODULE_14___default().label) || ""),
                                                                    children: "Company Name"
                                                                }),
                                                                trigger: "blur",
                                                                rules: [
                                                                    {
                                                                        required: true,
                                                                        message: "please enter the Company Name"
                                                                    },
                                                                    {
                                                                        validator: function(rule, value) {
                                                                            return !!value;
                                                                        },
                                                                        message: ""
                                                                    }
                                                                ]
                                                            }),
                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_douyinfe_semi_ui__WEBPACK_IMPORTED_MODULE_3__/* .Form.Input */ .l0.Input, {
                                                                className: (_index_module_scss__WEBPACK_IMPORTED_MODULE_14___default().input),
                                                                field: "truename",
                                                                placeholder: "please enter the name of Contact person",
                                                                label: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                                                    className: "jsx-c261a8235e8d453e" + " " + ((_index_module_scss__WEBPACK_IMPORTED_MODULE_14___default().label) || ""),
                                                                    children: "Contact person"
                                                                }),
                                                                trigger: "blur",
                                                                rules: [
                                                                    {
                                                                        required: true,
                                                                        message: "please enter the name of Contact person"
                                                                    },
                                                                    {
                                                                        validator: function(rule, value) {
                                                                            return !!value;
                                                                        },
                                                                        message: ""
                                                                    }
                                                                ]
                                                            }),
                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_douyinfe_semi_ui__WEBPACK_IMPORTED_MODULE_3__/* .Form.InputNumber */ .l0.InputNumber, {
                                                                className: (_index_module_scss__WEBPACK_IMPORTED_MODULE_14___default().input),
                                                                field: "mobile",
                                                                hideButtons: true,
                                                                placeholder: "please enter your phone number",
                                                                label: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                                                    className: "jsx-c261a8235e8d453e" + " " + ((_index_module_scss__WEBPACK_IMPORTED_MODULE_14___default().label) || ""),
                                                                    children: "Mobile"
                                                                }),
                                                                trigger: "blur",
                                                                rules: [
                                                                    {
                                                                        required: true,
                                                                        message: "please enter your phone number"
                                                                    },
                                                                    {
                                                                        validator: function(rule, value) {
                                                                            return !!value;
                                                                        },
                                                                        message: ""
                                                                    }
                                                                ]
                                                            }),
                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_douyinfe_semi_ui__WEBPACK_IMPORTED_MODULE_3__/* .Form.RadioGroup */ .l0.RadioGroup, {
                                                                field: "gender",
                                                                style: {
                                                                    height: "56px"
                                                                },
                                                                label: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                                                    className: "jsx-c261a8235e8d453e",
                                                                    children: "Gender"
                                                                }),
                                                                className: "gender",
                                                                children: [
                                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_douyinfe_semi_ui__WEBPACK_IMPORTED_MODULE_3__/* .Form.Radio */ .l0.Radio, {
                                                                        value: "1",
                                                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                                                            style: {
                                                                                marginRight: "40px"
                                                                            },
                                                                            className: "jsx-c261a8235e8d453e",
                                                                            children: "Mr"
                                                                        })
                                                                    }),
                                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_douyinfe_semi_ui__WEBPACK_IMPORTED_MODULE_3__/* .Form.Radio */ .l0.Radio, {
                                                                        value: "2",
                                                                        children: "Mrs"
                                                                    })
                                                                ]
                                                            }),
                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_douyinfe_semi_ui__WEBPACK_IMPORTED_MODULE_3__/* .Form.Input */ .l0.Input, {
                                                                className: (_index_module_scss__WEBPACK_IMPORTED_MODULE_14___default().input),
                                                                field: "position",
                                                                placeholder: "please enter your position",
                                                                label: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                                                    className: "jsx-c261a8235e8d453e" + " " + ((_index_module_scss__WEBPACK_IMPORTED_MODULE_14___default().label) || ""),
                                                                    children: "Position"
                                                                }),
                                                                trigger: "blur"
                                                            }),
                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_douyinfe_semi_ui__WEBPACK_IMPORTED_MODULE_3__/* .Form.Select */ .l0.Select, {
                                                                field: "country_id",
                                                                label: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                                                    className: "jsx-c261a8235e8d453e" + " " + ((_index_module_scss__WEBPACK_IMPORTED_MODULE_14___default().label) || ""),
                                                                    children: "Country"
                                                                }),
                                                                placeholder: "please select your country",
                                                                onSelect: function(value, option) {
                                                                    // console.log(value,option);
                                                                    formRef.current.setValue("phone_code", "+" + option.code);
                                                                    setVisible(value == 256);
                                                                },
                                                                rules: [
                                                                    {
                                                                        required: true,
                                                                        message: "please select your country"
                                                                    }, 
                                                                ],
                                                                optionList: country
                                                            }),
                                                            visible && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_douyinfe_semi_ui__WEBPACK_IMPORTED_MODULE_3__/* .Form.Slot */ .l0.Slot, {
                                                                label: {
                                                                    text: "Area",
                                                                    required: true
                                                                },
                                                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                                    className: "jsx-c261a8235e8d453e" + " " + (classnames__WEBPACK_IMPORTED_MODULE_7___default()([
                                                                        (_index_module_scss__WEBPACK_IMPORTED_MODULE_14___default().area),
                                                                        "slot"
                                                                    ]) || ""),
                                                                    children: [
                                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_douyinfe_semi_ui__WEBPACK_IMPORTED_MODULE_3__/* .Form.Select */ .l0.Select, {
                                                                            field: "province_id",
                                                                            label: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {}),
                                                                            placeholder: "Province",
                                                                            rules: [
                                                                                {
                                                                                    required: true,
                                                                                    message: "Please select your province"
                                                                                }, 
                                                                            ],
                                                                            optionList: region,
                                                                            onSelect: function(value, option) {
                                                                                getRegion(value);
                                                                                formRef.current.reset([
                                                                                    "city_id"
                                                                                ]);
                                                                            }
                                                                        }),
                                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_douyinfe_semi_ui__WEBPACK_IMPORTED_MODULE_3__/* .Form.Select */ .l0.Select, {
                                                                            field: "city_id",
                                                                            label: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {}),
                                                                            placeholder: "City",
                                                                            rules: [
                                                                                {
                                                                                    required: true,
                                                                                    message: "Please select your city"
                                                                                }, 
                                                                            ],
                                                                            optionList: city,
                                                                            onSelect: function(value, option) {
                                                                                formRef.current.setValue("phone_zone", option.area_code);
                                                                            }
                                                                        })
                                                                    ]
                                                                })
                                                            }),
                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_douyinfe_semi_ui__WEBPACK_IMPORTED_MODULE_3__/* .Form.Slot */ .l0.Slot, {
                                                                label: {
                                                                    text: "Tel"
                                                                },
                                                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                                    className: "jsx-c261a8235e8d453e" + " " + (classnames__WEBPACK_IMPORTED_MODULE_7___default()([
                                                                        (_index_module_scss__WEBPACK_IMPORTED_MODULE_14___default().phone),
                                                                        "slot"
                                                                    ]) || ""),
                                                                    children: [
                                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_douyinfe_semi_ui__WEBPACK_IMPORTED_MODULE_3__/* .Form.Input */ .l0.Input, {
                                                                            className: (_index_module_scss__WEBPACK_IMPORTED_MODULE_14___default().input),
                                                                            field: "phone_code",
                                                                            label: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {}),
                                                                            readonly: true,
                                                                            initValue: "+86"
                                                                        }),
                                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_douyinfe_semi_ui__WEBPACK_IMPORTED_MODULE_3__/* .Form.Input */ .l0.Input, {
                                                                            className: (_index_module_scss__WEBPACK_IMPORTED_MODULE_14___default().input),
                                                                            field: "phone_zone",
                                                                            placeholder: "Area code",
                                                                            label: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {})
                                                                        }),
                                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_douyinfe_semi_ui__WEBPACK_IMPORTED_MODULE_3__/* .Form.InputNumber */ .l0.InputNumber, {
                                                                            className: (_index_module_scss__WEBPACK_IMPORTED_MODULE_14___default().input),
                                                                            hideButtons: true,
                                                                            field: "phone",
                                                                            placeholder: "Number",
                                                                            label: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {})
                                                                        })
                                                                    ]
                                                                })
                                                            }),
                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_douyinfe_semi_ui__WEBPACK_IMPORTED_MODULE_3__/* .Form.Input */ .l0.Input, {
                                                                className: (_index_module_scss__WEBPACK_IMPORTED_MODULE_14___default().input),
                                                                field: "email",
                                                                placeholder: "Please enter your email address",
                                                                label: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                                                    className: "jsx-c261a8235e8d453e" + " " + ((_index_module_scss__WEBPACK_IMPORTED_MODULE_14___default().label) || ""),
                                                                    children: "Email"
                                                                }),
                                                                trigger: "blur",
                                                                rules: [
                                                                    {
                                                                        required: true,
                                                                        message: "Please enter your email address"
                                                                    },
                                                                    {
                                                                        validator: function(rule, value) {
                                                                            return !!value;
                                                                        },
                                                                        message: ""
                                                                    }
                                                                ]
                                                            }),
                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_douyinfe_semi_ui__WEBPACK_IMPORTED_MODULE_3__/* .Form.Input */ .l0.Input, {
                                                                className: (_index_module_scss__WEBPACK_IMPORTED_MODULE_14___default().input),
                                                                field: "website",
                                                                placeholder: "Please enter the company website",
                                                                label: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                                                    className: "jsx-c261a8235e8d453e" + " " + ((_index_module_scss__WEBPACK_IMPORTED_MODULE_14___default().label) || ""),
                                                                    children: "Company Website"
                                                                })
                                                            }),
                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                                className: "jsx-c261a8235e8d453e" + " " + (classnames__WEBPACK_IMPORTED_MODULE_7___default()([
                                                                    (_index_module_scss__WEBPACK_IMPORTED_MODULE_14___default().twoCol),
                                                                    "profile"
                                                                ]) || ""),
                                                                children: [
                                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_douyinfe_semi_ui__WEBPACK_IMPORTED_MODULE_3__/* .Form.Input */ .l0.Input, {
                                                                        className: (_index_module_scss__WEBPACK_IMPORTED_MODULE_14___default().input),
                                                                        field: "company_type",
                                                                        placeholder: "please enter the company type",
                                                                        label: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                                                            className: "jsx-c261a8235e8d453e" + " " + ((_index_module_scss__WEBPACK_IMPORTED_MODULE_14___default().label) || ""),
                                                                            children: "Company Type"
                                                                        })
                                                                    }),
                                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_douyinfe_semi_ui__WEBPACK_IMPORTED_MODULE_3__/* .Form.TreeSelect */ .l0.TreeSelect, {
                                                                        field: "category_data",
                                                                        labelWidth: 110,
                                                                        renderFullLabel: renderLabel,
                                                                        dropdownStyle: {
                                                                            maxHeight: 400,
                                                                            overflow: "auto"
                                                                        },
                                                                        treeData: prodCate,
                                                                        placeholder: "please choose",
                                                                        disableStrictly: true,
                                                                        leafOnly: true,
                                                                        label: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                                                            className: "jsx-c261a8235e8d453e" + " " + (classnames__WEBPACK_IMPORTED_MODULE_7___default()([
                                                                                (_index_module_scss__WEBPACK_IMPORTED_MODULE_14___default().label)
                                                                            ]) || ""),
                                                                            children: "Exhibit of Profiles"
                                                                        }),
                                                                        rules: [
                                                                            {
                                                                                required: true,
                                                                                message: "please choose"
                                                                            }, 
                                                                        ]
                                                                    })
                                                                ]
                                                            })
                                                        ]
                                                    })
                                                ]
                                            });
                                        }
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                        className: "jsx-c261a8235e8d453e" + " " + ((_index_module_scss__WEBPACK_IMPORTED_MODULE_14___default().vcode) || ""),
                                        children: [
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("input", {
                                                placeholder: "Security code",
                                                value: verify,
                                                onChange: function(e) {
                                                    return setVerify(e.target.value);
                                                },
                                                className: "jsx-c261a8235e8d453e"
                                            }),
                                            reload && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                                                src: reload,
                                                onClick: function() {
                                                    return getVerify();
                                                },
                                                alt: "",
                                                className: "jsx-c261a8235e8d453e"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                        onClick: btnClick,
                                        className: "jsx-c261a8235e8d453e" + " " + ((_index_module_scss__WEBPACK_IMPORTED_MODULE_14___default().subBtn) || ""),
                                        children: "Submit"
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                        className: "jsx-c261a8235e8d453e",
                        children: "纽伦堡会展(上海)有限公司 版权所有 \xa9 2025 沪ICP备09011147号-7"
                    })
                ]
            }),
            (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((styled_jsx_style__WEBPACK_IMPORTED_MODULE_1___default()), {
                id: "c261a8235e8d453e",
                children: '@media screen and (max-width:887px){.semi-form-field-label{text-align:left!important;padding-top:0;width:100%!important}.semi-form-field{-webkit-box-orient:vertical;-webkit-box-direction:normal;-webkit-flex-direction:column;-moz-box-orient:vertical;-moz-box-direction:normal;-ms-flex-direction:column;flex-direction:column;padding-top:0!important}.type .semi-form-field{padding-top:12px!important}}.semi-form-field-label-required .semi-form-field-label-text::before{content:"*";margin-right:4px;color:var(--semi-color-danger);font-weight:600}.semi-form-field-label-text::after{display:none}.semi-tree-option{padding:8px 12px!important}.semi-form-field-label{font-weight:500;padding-right:20px;margin-top:13px;font-size:16px}.profile>:last-child label{margin-top:0!important}.semi-input-wrapper,.semi-select,.semi-tree-select{width:100%;background:white!important;height:56px;line-height:56px;border:1px solid#ddd;-webkit-border-radius:4px;-moz-border-radius:4px;border-radius:4px;&:hover{border:1px solid#fcb814}}.semi-form-field{padding:0 0 20px;-webkit-box-pack:end;-webkit-justify-content:flex-end;-moz-box-pack:end;-ms-flex-pack:end;justify-content:flex-end}.semi-radio-inner,.semi-radio-inner-display,.semi-checkbox-inner,.semi-checkbox-inner-display{width:18px!important;height:18px!important}.semi-checkbox-checked .semi-checkbox-inner-display,.semi-radio-checked .semi-radio-inner-display{border:orange!important;background:orange!important;-webkit-box-shadow:none;-moz-box-shadow:none;box-shadow:none}.semi-icon-default{font-size:18px!important}.slot .semi-form-field-label{display:none!important}.semi-form-slot{padding:0!important}.slot .semi-form-field{padding:0;padding:12px 0}.gender .semi-radio{-webkit-box-align:center;-webkit-align-items:center;-moz-box-align:center;-ms-flex-align:center;align-items:center;zoom:1.2}.semi-input-number{width:100%}.type{.semi-form-field-label{\r\n                display: none !important;}.semi-radio-inner{-webkit-transform:translateY(18px)!important;-moz-transform:translateY(18px)!important;-ms-transform:translateY(18px)!important;-o-transform:translateY(18px)!important;transform:translateY(18px)!important}.semi-radio-content,.semi-form-field{-webkit-box-flex:1;-webkit-flex:1;-moz-box-flex:1;-ms-flex:1;flex:1}.semi-radioGroup-vertical{row-gap:0}'
            })
        ]
    });
};
var __N_SSP = true;
/* harmony default export */ __webpack_exports__["default"] = (Apply);


/***/ }),

/***/ 48847:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "sC": function() { return /* binding */ PRODDOMAIN; },
/* harmony export */   "zE": function() { return /* binding */ PRODFORNTDOMAIN; }
/* harmony export */ });
/* unused harmony exports DEVDOMAIN, getIsMobile, getIsSupportWebp */
var DEVDOMAIN = "http://localhost:3001";
// export const PRODDOMAIN = "http://system.icef.com.cn";
var PRODDOMAIN = "https://system.cbcechina.com";
// export const PRODDOMAIN = "http://cbce.smartinfo.cn";
var PRODFORNTDOMAIN = "https://www.cbcechina.com";
var getIsMobile = function(context) {
    var ref = context.ctx.req || {}, _headers = ref.headers, headers = _headers === void 0 ? {} : _headers;
    return /mobile|android|iphone|ipad|phone/i.test((headers["user-agent"] || "").toLowerCase());
};
var getIsSupportWebp = function(context) {
    var ref;
    var ref1 = context.ctx.req || {}, _headers = ref1.headers, headers = _headers === void 0 ? {} : _headers;
    return (ref = headers.accept) === null || ref === void 0 ? void 0 : ref.includes("image/webp");
};


/***/ }),

/***/ 25838:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "c": function() { return /* binding */ getHead; }
/* harmony export */ });
/* unused harmony export getServerSideProps */
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(47568);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(97582);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _utils__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(48847);
/* harmony import */ var axios__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(9669);
/* harmony import */ var axios__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(axios__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(9008);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_head__WEBPACK_IMPORTED_MODULE_2__);






var searchNode = function(data, path) {
    for(var i = 0; i < (data === null || data === void 0 ? void 0 : data.length); i++){
        var item = data[i];
        if (item.pathinfo === path) {
            return item;
        }
        if (item.childlist && Array.isArray(item.childlist)) {
            var found = searchNode(item.childlist, path);
            if (found) {
                return found;
            }
        }
    }
    return null;
};
var getServerSideProps = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(function(context) {
        var lang, path, data, node, ref, _data;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_4__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    console.log("${PRODDOMAIN}");
                    lang = context.resolvedUrl.slice(0, 3) === "/en" ? "en" : "cn";
                    path = lang === "cn" ? context.resolvedUrl : context.resolvedUrl.slice(3);
                    return [
                        4,
                        axios__WEBPACK_IMPORTED_MODULE_1___default().get("".concat(_utils__WEBPACK_IMPORTED_MODULE_5__/* .PRODDOMAIN */ .sC, "/api/menu?lang=").concat(lang))
                    ];
                case 1:
                    data = _state.sent().data;
                    node = searchNode(data.data.menu_tree, path);
                    return [
                        4,
                        axios__WEBPACK_IMPORTED_MODULE_1___default().get("".concat(_utils__WEBPACK_IMPORTED_MODULE_5__/* .PRODDOMAIN */ .sC, "/api/menu_info/").concat(node === null || node === void 0 ? void 0 : node.id), {
                            params: {
                                lang: lang
                            }
                        })
                    ];
                case 2:
                    ref = _state.sent(), _data = ref.data;
                    return [
                        2,
                        {
                            props: {
                                navDetail: _data.data || {}
                            }
                        }
                    ];
            }
        });
    });
    return function getServerSideProps(context) {
        return _ref.apply(this, arguments);
    };
}();
var getHead = function(navDetail) {
    var ref, ref1, ref2, ref3;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)((next_head__WEBPACK_IMPORTED_MODULE_2___default()), {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("title", {
                children: [
                    (navDetail === null || navDetail === void 0 ? void 0 : (ref = navDetail.info) === null || ref === void 0 ? void 0 : ref.meta_title) || (navDetail === null || navDetail === void 0 ? void 0 : (ref1 = navDetail.info) === null || ref1 === void 0 ? void 0 : ref1.name),
                    " "
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "keywords",
                content: navDetail === null || navDetail === void 0 ? void 0 : (ref2 = navDetail.info) === null || ref2 === void 0 ? void 0 : ref2.meta_kws
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "description",
                content: navDetail === null || navDetail === void 0 ? void 0 : (ref3 = navDetail.info) === null || ref3 === void 0 ? void 0 : ref3.meta_desc
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("script", {
                dangerouslySetInnerHTML: {
                    __html: '\nvar _hmt = _hmt || [];\n(function() {\n  var hm = document.createElement("script");\n  hm.src = "https://hm.baidu.com/hm.js?d88812b706e7e120a8177951b2a61433";\n  var s = document.getElementsByTagName("script")[0]; \n  s.parentNode.insertBefore(hm, s);\n})();\n    '
                }
            })
        ]
    });
};



/***/ }),

/***/ 69288:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"container":"apply_container__1FNJJ","content":"apply_content__tI9sE","title":"apply_title__noNiR","backBtn":"apply_backBtn__7lp86","subBtn":"apply_subBtn__o_23S","form":"apply_form__8kqgA","type":"apply_type__YwJi5","radioRight":"apply_radioRight__bADK9","label":"apply_label__zB9WW","info":"apply_info__sn5Y4","area":"apply_area__1rhXz","phone":"apply_phone__E99eE","twoCol":"apply_twoCol__aMNsI","vcode":"apply_vcode__lrIxN","allow":"apply_allow__OqjbK"};

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [3662,9774,2888,179], function() { return __webpack_exec__(8927); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);